export const getSafeHref = (href: string): string => {
  const value = href.trim();

  if (!value || value.startsWith('//')) {
    return '#';
  }

  if (value.startsWith('/') || value.startsWith('#') || value.startsWith('?')) {
    return value;
  }

  try {
    const protocol = new URL(value, window.location.origin).protocol;
    return protocol === 'http:' || protocol === 'https:' ? value : '#';
  } catch {
    return '#';
  }
};